import { render, staticRenderFns } from "./AddAutomationRule.vue?vue&type=template&id=37ce0a51&scoped=true&"
import script from "./AddAutomationRule.vue?vue&type=script&lang=js&"
export * from "./AddAutomationRule.vue?vue&type=script&lang=js&"
import style0 from "./AddAutomationRule.vue?vue&type=style&index=0&id=37ce0a51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce0a51",
  null
  
)

export default component.exports